export enum StoredCookies {
	ACCESS_TOKEN = 'ACCESS_TOKEN',
	USERNAME = 'USERNAME',
	REFRESH_TOKEN = 'REFRESH_TOKEN',
}
